import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DealsHomeComponent } from './deals-home/deals-home.component';
import { DealsCommitteeDashboardComponent } from './deals-committee-dashboard/deals-committee-dashboard.component';
import { SharedModule } from '../components/shared.module';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { TaxCreditsComponent } from './deals-subcomponents/tax-credits/tax-credits.component';
import { DispositionsComponent } from './deals-subcomponents/dispositions/dispositions.component';
import { StatusAndPipelineDatesComponent } from './deals-subcomponents/status-and-pipeline-dates/status-and-pipeline-dates.component';
import { DealDatesComponent } from './deals-subcomponents/deal-dates/deal-dates.component';
import { MatTableModule } from '@angular/material/table';
import { DealInformationComponent } from './deals-subcomponents/deal-information/deal-information.component';
import { MatSortModule } from '@angular/material/sort';
import { TaxCreditsTableComponent } from './deals-subcomponents/tax-credits/tax-credits-table/tax-credits-table.component';
import { ParticipantsComponent } from './deals-subcomponents/participants/participants.component';
import { NotesComponent } from './deals-subcomponents/notes/notes.component';
import { CreditOutletsComponent } from './deals-subcomponents/credit-outlets/credit-outlets.component';
import { FundParticipantsTableComponent } from './deals-subcomponents/credit-outlets/fund-participants-table/fund-participants-table.component';
import { CreditOutletsTableComponent } from './deals-subcomponents/credit-outlets/credit-outlets-table/credit-outlets-table.component';
import { LoansComponent } from './deals-subcomponents/loans/loans.component';
import { LtModelExportsComponent } from './deals-subcomponents/lt-model-exports/lt-model-exports.component';
import { EsgSupportiveServicesComponent } from './deals-subcomponents/esg-supportive-services/esg-supportive-services.component';
import { TaxCreditApplicationsComponent } from './deals-subcomponents/tax-credit-applications/tax-credit-applications.component';
import { TaxCreditApplicationsTableComponent } from './deals-subcomponents/tax-credit-applications/tax-credit-applications-table/tax-credit-applications-table.component';
import { ConstructionComponent } from './deals-subcomponents/construction/construction.component';
import { AssetManagementComponent } from './deals-subcomponents/asset-management/asset-management.component';
import { DispositionInfoTableComponent } from './deals-subcomponents/dispositions/disposition-info-table/disposition-info-table.component';
import { DistributionsTableComponent } from './deals-subcomponents/dispositions/distributions-table/distributions-table.component';
import { OtherDispositionDatesTableComponent } from './deals-subcomponents/dispositions/other-disposition-dates-table/other-disposition-dates-table.component';
import { AddressesComponent } from './deals-subcomponents/addresses/addresses.component';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {AddressAutocompleteComponent} from "../components/address-autocomplete/address-autocomplete.component";
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { UnsubscribeConfirmationComponent } from './deals-subcomponents/status-and-pipeline-dates/unsubscribe-confirmation/unsubscribe-confirmation.component';
import { MatDialogModule } from '@angular/material/dialog';
import { DeadDealConfirmationComponent } from './deals-subcomponents/status-and-pipeline-dates/dead-deal-confirmation/dead-deal-confirmation.component';
import { ResurrectConfirmationComponent } from './deals-subcomponents/status-and-pipeline-dates/resurrect-confirmation/resurrect-confirmation.component';
import { TabularPipelineDatesComponent } from './deals-subcomponents/status-and-pipeline-dates/tabular-pipeline-dates/tabular-pipeline-dates.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { AddSetAsideTypeConfirmationComponent } from './deals-subcomponents/esg-supportive-services/add-set-aside-type-confirmation/add-set-aside-type-confirmation.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { AddTaxCreditAppConfirmationComponent } from './deals-subcomponents/tax-credit-applications/add-tax-credit-app-confirmation/add-tax-credit-app-confirmation.component';
import { CommitteeApprovalsModule } from '../committee-approval-dashboard/committee-approvals/committee-approvals.module';
import { CommitteeItemsModule } from '../committee-approval-dashboard/committee-items/committee-items.module';
import { CommitteeConditionsModule } from '../committee-approval-dashboard/committee-conditions/committee-conditions.module';
import { AddSupportiveServicesIncludedConfirmationComponent } from './deals-subcomponents/deal-information/add-supportive-services-included-confirmation/add-supportive-services-included-confirmation.component';
import { DeleteDealConfirmationComponent } from './deals-home/delete-deal-confirmation/delete-deal-confirmation.component';
import { UploaderModule } from '../components/uploader/uploader.module';
import { PricingComponent } from './deals-subcomponents/pricing/pricing.component';
import { DealDispositionsComponent } from './deal-dispositions/deal-dispositions.component';
import { DealTermsComponent } from './deal-terms/deal-terms.component';
import {MatChipsModule} from "@angular/material/chips";
import { DealsClosingDashboardComponent } from './deals-closing-dashboard/deals-closing-dashboard.component';

@NgModule({
    declarations: [
        DealsHomeComponent,
        DealsCommitteeDashboardComponent,
        TaxCreditsComponent,
        DispositionsComponent,
        StatusAndPipelineDatesComponent,
        DealDatesComponent,
        DealInformationComponent,
        TaxCreditsTableComponent,
        ParticipantsComponent,
        NotesComponent,
        CreditOutletsComponent,
        FundParticipantsTableComponent,
        CreditOutletsTableComponent,
        LoansComponent,
        LtModelExportsComponent,
        EsgSupportiveServicesComponent,
        TaxCreditApplicationsComponent,
        TaxCreditApplicationsTableComponent,
        ConstructionComponent,
        AssetManagementComponent,
        DispositionInfoTableComponent,
        DistributionsTableComponent,
        OtherDispositionDatesTableComponent,
        AddressesComponent,
        UnsubscribeConfirmationComponent,
        DeadDealConfirmationComponent,
        ResurrectConfirmationComponent,
        TabularPipelineDatesComponent,
        AddSetAsideTypeConfirmationComponent,
        AddTaxCreditAppConfirmationComponent,
        AddSupportiveServicesIncludedConfirmationComponent,
        DeleteDealConfirmationComponent,
        PricingComponent,
        DealDispositionsComponent,
        DealTermsComponent,
        DealsClosingDashboardComponent,
    ],
  imports: [
    SharedModule,
    CommonModule,
    MatAutocompleteModule,
    MatCardModule,
    MatIconModule,
    MatChipsModule,
    MatExpansionModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatMenuModule,
    MatTableModule,
    MatSortModule,
    MatInputModule,
    MatSnackBarModule,
    FormsModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatDialogModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSidenavModule,
    CommitteeItemsModule,
    CommitteeConditionsModule,
    CommitteeApprovalsModule,
    UploaderModule,
  ],
})
export class DealsModule {}
